/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateItemBody,
  Error,
  GetItems200,
  GetItemsParams,
  ItemResponse,
  UpdateItemBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a new product or service item for use in invoices. Items can include pricing, tax information (inline or by reference), and unit details. All fields except name are optional.
 * @summary Create a new item
 */
export type createItemResponse201 = {
  data: ItemResponse
  status: 201
}

export type createItemResponse400 = {
  data: Error
  status: 400
}

export type createItemResponse401 = {
  data: Error
  status: 401
}

export type createItemResponse403 = {
  data: Error
  status: 403
}

export type createItemResponse404 = {
  data: Error
  status: 404
}

export type createItemResponse422 = {
  data: ValidationError
  status: 422
}

export type createItemResponse500 = {
  data: Error
  status: 500
}

export type createItemResponseSuccess = (createItemResponse201) & {
  headers: Headers;
};
export type createItemResponseError = (createItemResponse400 | createItemResponse401 | createItemResponse403 | createItemResponse404 | createItemResponse422 | createItemResponse500) & {
  headers: Headers;
};

export type createItemResponse = (createItemResponseSuccess | createItemResponseError)

export const getCreateItemUrl = () => {


  

  return `/items`
}

export const createItem = async (createItemBody: CreateItemBody, options?: RequestInit): Promise<createItemResponse> => {
  
  return customFetch<createItemResponse>(getCreateItemUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createItemBody,)
  }
);}
  

/**
 * Retrieve a paginated list of items (products and services) with optional filtering and sorting. Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all items
 */
export type getItemsResponse200 = {
  data: GetItems200
  status: 200
}

export type getItemsResponse400 = {
  data: Error
  status: 400
}

export type getItemsResponse401 = {
  data: Error
  status: 401
}

export type getItemsResponse403 = {
  data: Error
  status: 403
}

export type getItemsResponse404 = {
  data: Error
  status: 404
}

export type getItemsResponse500 = {
  data: Error
  status: 500
}

export type getItemsResponseSuccess = (getItemsResponse200) & {
  headers: Headers;
};
export type getItemsResponseError = (getItemsResponse400 | getItemsResponse401 | getItemsResponse403 | getItemsResponse404 | getItemsResponse500) & {
  headers: Headers;
};

export type getItemsResponse = (getItemsResponseSuccess | getItemsResponseError)

export const getGetItemsUrl = (params?: GetItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/items?${stringifiedParams}` : `/items`
}

export const getItems = async (params?: GetItemsParams, options?: RequestInit): Promise<getItemsResponse> => {
  
  return customFetch<getItemsResponse>(getGetItemsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing product or service item. Only the provided fields are updated. Pricing and taxes are recalculated consistently with item creation rules.
 * @summary Update an item
 */
export type updateItemResponse200 = {
  data: ItemResponse
  status: 200
}

export type updateItemResponse400 = {
  data: Error
  status: 400
}

export type updateItemResponse401 = {
  data: Error
  status: 401
}

export type updateItemResponse403 = {
  data: Error
  status: 403
}

export type updateItemResponse404 = {
  data: Error
  status: 404
}

export type updateItemResponse422 = {
  data: ValidationError
  status: 422
}

export type updateItemResponse500 = {
  data: Error
  status: 500
}

export type updateItemResponseSuccess = (updateItemResponse200) & {
  headers: Headers;
};
export type updateItemResponseError = (updateItemResponse400 | updateItemResponse401 | updateItemResponse403 | updateItemResponse404 | updateItemResponse422 | updateItemResponse500) & {
  headers: Headers;
};

export type updateItemResponse = (updateItemResponseSuccess | updateItemResponseError)

export const getUpdateItemUrl = (id: string,) => {


  

  return `/items/${id}`
}

export const updateItem = async (id: string,
    updateItemBody: UpdateItemBody, options?: RequestInit): Promise<updateItemResponse> => {
  
  return customFetch<updateItemResponse>(getUpdateItemUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateItemBody,)
  }
);}
  

/**
 * Soft delete an item. The item will be moved to the trash and can be restored later.
 * @summary Delete an item
 */
export type deleteItemResponse204 = {
  data: void
  status: 204
}

export type deleteItemResponse400 = {
  data: Error
  status: 400
}

export type deleteItemResponse401 = {
  data: Error
  status: 401
}

export type deleteItemResponse403 = {
  data: Error
  status: 403
}

export type deleteItemResponse404 = {
  data: Error
  status: 404
}

export type deleteItemResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteItemResponse500 = {
  data: Error
  status: 500
}

export type deleteItemResponseSuccess = (deleteItemResponse204) & {
  headers: Headers;
};
export type deleteItemResponseError = (deleteItemResponse400 | deleteItemResponse401 | deleteItemResponse403 | deleteItemResponse404 | deleteItemResponse422 | deleteItemResponse500) & {
  headers: Headers;
};

export type deleteItemResponse = (deleteItemResponseSuccess | deleteItemResponseError)

export const getDeleteItemUrl = (id: string,) => {


  

  return `/items/${id}`
}

export const deleteItem = async (id: string, options?: RequestInit): Promise<deleteItemResponse> => {
  
  return customFetch<deleteItemResponse>(getDeleteItemUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Restore a soft-deleted item from the trash.
 * @summary Restore a deleted item
 */
export type restoreItemResponse200 = {
  data: ItemResponse
  status: 200
}

export type restoreItemResponse400 = {
  data: Error
  status: 400
}

export type restoreItemResponse401 = {
  data: Error
  status: 401
}

export type restoreItemResponse403 = {
  data: Error
  status: 403
}

export type restoreItemResponse404 = {
  data: Error
  status: 404
}

export type restoreItemResponse422 = {
  data: ValidationError
  status: 422
}

export type restoreItemResponse500 = {
  data: Error
  status: 500
}

export type restoreItemResponseSuccess = (restoreItemResponse200) & {
  headers: Headers;
};
export type restoreItemResponseError = (restoreItemResponse400 | restoreItemResponse401 | restoreItemResponse403 | restoreItemResponse404 | restoreItemResponse422 | restoreItemResponse500) & {
  headers: Headers;
};

export type restoreItemResponse = (restoreItemResponseSuccess | restoreItemResponseError)

export const getRestoreItemUrl = (id: string,) => {


  

  return `/items/${id}/restore`
}

export const restoreItem = async (id: string, options?: RequestInit): Promise<restoreItemResponse> => {
  
  return customFetch<restoreItemResponse>(getRestoreItemUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Permanently delete a soft-deleted item. Only items in the trash can be permanently deleted.
 * @summary Permanently delete an item
 */
export type permanentDeleteItemResponse204 = {
  data: void
  status: 204
}

export type permanentDeleteItemResponse400 = {
  data: Error
  status: 400
}

export type permanentDeleteItemResponse401 = {
  data: Error
  status: 401
}

export type permanentDeleteItemResponse403 = {
  data: Error
  status: 403
}

export type permanentDeleteItemResponse404 = {
  data: Error
  status: 404
}

export type permanentDeleteItemResponse422 = {
  data: ValidationError
  status: 422
}

export type permanentDeleteItemResponse500 = {
  data: Error
  status: 500
}

export type permanentDeleteItemResponseSuccess = (permanentDeleteItemResponse204) & {
  headers: Headers;
};
export type permanentDeleteItemResponseError = (permanentDeleteItemResponse400 | permanentDeleteItemResponse401 | permanentDeleteItemResponse403 | permanentDeleteItemResponse404 | permanentDeleteItemResponse422 | permanentDeleteItemResponse500) & {
  headers: Headers;
};

export type permanentDeleteItemResponse = (permanentDeleteItemResponseSuccess | permanentDeleteItemResponseError)

export const getPermanentDeleteItemUrl = (id: string,) => {


  

  return `/items/${id}/permanent`
}

export const permanentDeleteItem = async (id: string, options?: RequestInit): Promise<permanentDeleteItemResponse> => {
  
  return customFetch<permanentDeleteItemResponse>(getPermanentDeleteItemUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

